export default "assets/logo-black-80985389.png";